/**
 * CRM 頁面權限常數定義
 *
 * 權限控制以「父路由」為單位，子路由自動繼承權限
 * code_name 對應 router.js 的 route name
 */

/**
 * 所有可用的 CRM 頁面權限列表（17 個）
 *
 * 注意：此列表應該從後端 GET /api/permissions 動態取得
 * 這裡作為 fallback 或開發時的預設值
 *
 * @type {Array<{id?: number, name: string, code_name: string}>}
 */
export const CRM_PERMISSIONS = [
  {
    name: '約診狀態表',
    code_name: 'home'
  },
  {
    name: '線上約診',
    code_name: 'onlineReserve'
  },
  {
    name: '改約名單',
    code_name: 'reschedule'
  },
  {
    name: '術後關懷',
    code_name: 'operativeCare'
  },
  {
    name: '訊息發送',
    code_name: 'message'
  },
  {
    name: '線上預約設定',
    code_name: 'freeTime'
  },
  {
    name: '我的病人',
    code_name: 'patients'
  },
  {
    name: '評價總覽',
    code_name: 'review'
  },
  {
    name: '上傳專區',
    code_name: 'upload'
  },
  {
    name: '術前衛教設定',
    code_name: 'healthEducation'
  },
  {
    name: '術後關懷設定',
    code_name: 'careTemplates'
  },
  {
    name: '診所資訊設定',
    code_name: 'settings'
  },
  {
    name: '統計數據',
    code_name: 'analytics'
  },
  {
    name: 'LINE智能助理權限設定',
    code_name: 'adminSettings'
  },
  {
    name: 'AI智能客服',
    code_name: 'AICustomerService'
  },
  {
    name: '詢問留言板',
    code_name: 'question'
  },
  {
    name: '連結小工具',
    code_name: 'superLink'
  }
]

/**
 * 所有權限的 code_name 列表（用於主權限帳號的預設權限）
 */
export const ALL_PERMISSION_CODES = CRM_PERMISSIONS.map(p => p.code_name)

/**
 * 根據 code_name 查找權限資訊
 * @param {string} code - 權限代碼
 * @returns {Object|undefined}
 */
export function getPermissionByCode(code) {
  return CRM_PERMISSIONS.find(p => p.code_name === code)
}

/**
 * 根據 route name 查找對應的權限 code
 *
 * 用於路由守衛：當用戶訪問某個路由時，找到對應的權限 code 來檢查
 * @param {string} routeName - 路由名稱
 * @returns {string|null}
 */
export function getPermissionCodeByRouteName(routeName) {
  // 直接比對 route name（大部分情況）
  const permission = CRM_PERMISSIONS.find(p => p.code_name === routeName)
  if (permission) {
    return permission.code_name
  }

  // 特殊處理：找父路由
  // 例如：用戶訪問 'messageSend'（子路由），應該檢查 'message'（父路由）權限
  // 這部分邏輯在 usePermission 裡處理
  return null
}
